import React, { createContext, useReducer, useContext } from "react";

const AuthStateContext = createContext();
const AuthDispatchContext = createContext();

const initialState = {
  isAuthenticated: !!localStorage.getItem("token"),
  token: localStorage.getItem("token"),
  token_type: localStorage.getItem("token_type"),
  userRole: localStorage.getItem("userRole"),
  user: null,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.access_token,
        token_type: action.payload.token_type,
        userRole: action.payload.role,
      };
    case "SET_USER":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        userRole: action.payload.role?.name,
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        ...initialState,
        isAuthenticated: false,
        token: null,
        userRole: null,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
};

export const useAuthState = () => useContext(AuthStateContext);
export const useAuthDispatch = () => useContext(AuthDispatchContext);
